import pageLoading from './lib/pageLoading.js';
import modalImage from './lib/modalImage.js';
// import { isPage, isMobile } from "./lib/util";
// import scrollEffect from "./lib/scrollEffect.js";
// import observer from "./lib/observer.js";
// import gsap from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";
// import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import topValidation from 'top-validation';
import '@/scss/design.scss';

document.addEventListener('DOMContentLoaded', () => {
  pageLoading();
  modalImage();


  //慣性スクロール
  const lenis = new Lenis();
  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }
  requestAnimationFrame(raf);


  //パララックス
  const pc = 768;
  let rellax = null;

  const setupRellax = () => {
    const windowWidth = window.innerWidth;

    if (windowWidth > pc) {
      if (!rellax) {
        rellax = new Rellax('.rellax', {
          round: true,
        });
      }
      return;
    }

    if (rellax) {
      rellax.destroy();
      rellax = null;
    }
  };

  setupRellax();
  window.addEventListener('resize', setupRellax);


  //バリデーション
  if (document.body.classList.contains('contact') ) {
    topValidation();
  }


  //ハンバーガーメニュー開閉　.hd_navが開く挙動
  const hdToggle = document.querySelector('.hd_toggle');
  const header = document.querySelector('.header');
  const hdNav = document.querySelector('.header .hd_nav');

  if (hdToggle && header && hdNav) {
    hdToggle.addEventListener('click', () => {
      header.classList.toggle('is-active');
      hdToggle.classList.toggle('is-active');
      hdNav.classList.toggle('is-active');
    });
  }


  //追従バナー　表示切替
  const isContactPage = document.body.classList.contains('contact');
  const triggerElement = isContactPage
    ? document.querySelector('.cta')
    : document.querySelector('.cta-image') || document.querySelector('.cta');
  const ecBanner = document.querySelector('.bnr-block');
  const bnrNone = document.querySelector('.bnr-none');

  if (bnrNone && ecBanner) {
    bnrNone.addEventListener('click', () => {
      ecBanner.classList.add('is-none');
    });
  }

  if (triggerElement && ecBanner) {
    ecBanner.style.transition = 'opacity 0.35s ease, visibility 0.35s ease, transform 0.3s';

    const showBanner = () => {
      ecBanner.style.opacity = '1';
      ecBanner.style.visibility = 'visible';
      ecBanner.style.pointerEvents = 'auto';
    };

    const hideBanner = () => {
      ecBanner.style.opacity = '0';
      ecBanner.style.visibility = 'hidden';
      ecBanner.style.pointerEvents = 'none';
    };

    const updateBannerVisibility = () => {
      const triggerY =
        triggerElement.getBoundingClientRect().top + window.scrollY - window.innerHeight;

      if (window.scrollY >= triggerY) {
        hideBanner();
      } else {
        showBanner();
      }
    };

    updateBannerVisibility();
    window.addEventListener('scroll', updateBannerVisibility, { passive: true });
    window.addEventListener('resize', updateBannerVisibility);
  }


  //タイトル 一文字ずつスライドイン
  const setupTitleSlideIn = () => {
    const targets = document.querySelectorAll('.title-sildein');

    targets.forEach((target) => {
      if (target.dataset.slideinReady === 'true') return;

      const text = target.textContent;
      if (!text) return;

      target.dataset.slideinReady = 'true';
      target.setAttribute('aria-label', text.trim());
      let charIndex = 0;

      const splitTextNodes = (node) => {
        const childNodes = [...node.childNodes];

        childNodes.forEach((child) => {
          if (child.nodeType === Node.TEXT_NODE) {
            const chars = child.textContent;
            if (!chars) return;

            const fragment = document.createDocumentFragment();
            [...chars].forEach((char) => {
              const span = document.createElement('span');
              span.className = 'title-sildein_char';
              span.textContent = char === ' ' ? '\u00A0' : char;
              span.style.setProperty('--char-index', charIndex);
              span.setAttribute('aria-hidden', 'true');
              fragment.appendChild(span);
              charIndex += 1;
            });

            child.replaceWith(fragment);
            return;
          }

          if (child.nodeType === Node.ELEMENT_NODE) {
            splitTextNodes(child);
          }
        });
      };

      splitTextNodes(target);
    });
  };

  const playTitleSlideIn = () => {
    const targets = document.querySelectorAll('.title-sildein');
    targets.forEach((target) => {
      target.classList.add('is-animate');
    });
  };

  setupTitleSlideIn();
  window.addEventListener('site-loading-complete', playTitleSlideIn, { once: true });

  const playSubCopyFadeIn = () => {
    const subCopy = document.querySelector('.js-sub-copy');
    if (!subCopy) return;

    setTimeout(() => {
      subCopy.classList.add('is-animate');
    }, 1800);
  };

  window.addEventListener('site-loading-complete', playSubCopyFadeIn, { once: true });


  // 子要素をディレイ付きで表示
  let parents = document.querySelectorAll('.js-fade-parent');

  function checkParentFade() {
    let windowHeight = window.innerHeight;

    parents.forEach(function(parent) {
      if (parent.classList.contains('is-shown')) return;

      let rect = parent.getBoundingClientRect();

      // 親が画面内に入ったら
      if (rect.top < windowHeight - 250) {
        parent.classList.add('is-shown');

        let children = parent.querySelectorAll('.js-fade-child');

        children.forEach(function(child, index) {
          setTimeout(function() {
            child.classList.add('is-scrollIn');
          }, index * 450);
        });
      }
    });
  }

  window.addEventListener('scroll', checkParentFade);
  window.addEventListener('load', checkParentFade);
  checkParentFade();

});
